const offlineSegmentsForm = {
  bindings: {
      selection: '<',
      segments: '<',
      segmentsText: '<',
      textSegment: '<',
      onFormSubmit: '&',
      onFileUpload: '&',
      hasEdit: '<',
  },
  templateUrl: '/modules/pis-tool/offline-audio/offline-segments-form/offline-segments-form.html',
  controller: 'OfflineSegmentsFormController',
};

angular
    .module('offline.module')
    .component('offlineSegmentsForm', offlineSegmentsForm);
